<template lang='pug' src='./custom-home-hero.pug'></template>

<script>
import HomeHeroDirective from './custom-home-hero.directive'
import ApptModal from 'components/modal/modal-appt/modal-appt'
import ScheduleModal from 'components/modal/modal-schedule/modal-schedule'

export default {
  props: ['content'],
  data: () => {
    return {
      props: {
        menu: {}
      },
      showApptModal: false,
      showScheduleModal: false
    }
  },
  directives: {
    HomeHeroDirective
  },
  components: {
    ApptModal,
    ScheduleModal
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-hero.vue?2d226452